/**
 * Returns the stored value from local storage, or undefined if a value doesn't exist for the key
 * provided.
 * @param key The key to use to retrieve the stored value
 */
export function getLocalStorageValue<T = unknown>(key: string): T | undefined {
  const value = window.localStorage.getItem(key);

  if (value) {
    return JSON.parse(value);
  }

  return undefined;
}

/**
 * Stores the given value in local storage using the key provided.
 * @param key The key to use to store the value
 * @param value The value to store
 */
export function setLocalStorageValue<T>(key: string, value: T): void {
  window.localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Clears the stored value in local storage using the key provided.
 * @param key The key to clear the value from
 */
export function clearLocalStorageValue(key: string): void {
  window.localStorage.removeItem(key);
}
